import { withStyles } from '@material-ui/core';
import React, { CSSProperties, FC } from 'react';
import { formatInCurrency } from '../common/formatters';
import { Typography } from '../common/Typography';

export type CreditMemoCellProps = {
  value: number;
  creditMemoAmount: number;
  options: Intl.NumberFormatOptions;
};

const Subtitle = withStyles({
  root: {
    position: 'absolute',
  },
})(Typography);

const crossedTextStyle: CSSProperties = {
  textDecoration: 'line-through',
  textDecorationThickness: 1,
};

const marginRight: CSSProperties = { marginRight: 15 };

export const CreditMemoCell: FC<CreditMemoCellProps> = ({ value, creditMemoAmount, options }) => (
  <>
    <Typography style={marginRight} component={'span'}>
      {formatInCurrency(value - creditMemoAmount, options)}{' '}
    </Typography>
    <Typography style={crossedTextStyle} color={'textSecondary'} component={'span'}>
      {formatInCurrency(value, options)}{' '}
    </Typography>
    <Subtitle variant={'subtitle1'} color={'textSecondary'}>
      Credit Memo: {formatInCurrency(creditMemoAmount, { ...options, style: 'currency' })}
    </Subtitle>
  </>
);
